
<template>
<!-- 家族列表 -->
  <div chass="app-container">
    <div class="chart-container">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-bottom:10px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>家族列表</h5>
              </span>
              <div class="ibox-tools" style="float:right;">
                <el-tooltip content="指标说明" placement="top">
                  <el-button size="mini" @click="dialogTipsVisible = true">
                    <svg-icon icon-class="ask" />
                  </el-button>
                </el-tooltip>
              </div>
            </div>

            <div>
              <el-select v-model="serverIds" size="mini" multiple collapse-tags filterable style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px;width:250px" placeholder="全部区服"
                @change="selectmultipleChanne($event, header_server_codeold,qufu_list,serverIds)">
                <el-option v-for="item in qufu_list" :value="item.value" :label="item.key" :key="item.value"></el-option>
              </el-select>
              <el-select v-model="countryIds" size="mini" multiple collapse-tags filterable style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px;width:250px" placeholder="全部国家"
                @change="countryIdsChanne($event, header_countryIds_codeold,guojia_list,countryIds)">
                <el-option v-for="item in guojia_list" :value="item.code" :label="item.name" :key="item.code"></el-option>
              </el-select>
              <el-input v-model="tiaojian.familyName" size="mini" style="width:250px;float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" placeholder="家族名称模糊搜索"></el-input>
              <el-date-picker style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" v-model="
      tiaojian.queryTime" type="date" size="mini" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
              <el-button type="primary" size="mini" @click="mohuchaxun" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">查询</el-button>

              <div style="float:right;margin-right:10px;cursor: pointer;margin-left:10px" title="下载">
                <el-button slot="reference" size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;margin-top:10px;" @click="houtai_exportExcel($event)"></el-button>
              </div>
              <!-- :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" -->
              <el-table :data="tableData.page.result" :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'6px 6px !important'}" class="tb-edit" border 
                v-loading="loadding">
                <el-table-column prop="serverName" fixed label="区服" show-overflow-tooltip min-width="150px">
                </el-table-column>
                <el-table-column prop="countryName" fixed label="国家" show-overflow-tooltip min-width="90px">
                </el-table-column>
                <el-table-column prop="familyName" fixed label="家族" show-overflow-tooltip min-width="120px">
                </el-table-column>
                <el-table-column prop="familyCreateTime" label="成立时间" show-overflow-tooltip min-width="90px">
                </el-table-column>
                <el-table-column prop="datetime" label="活跃日期" show-overflow-tooltip min-width="90px">
                </el-table-column>
                <el-table-column prop="activeFightingCapacity" label="活跃战斗力" show-overflow-tooltip min-width="100px">
                </el-table-column>
                <el-table-column prop="inactiveFightingCapacity" label="不活跃战斗力" show-overflow-tooltip min-width="110px">
                </el-table-column>
                <el-table-column prop="actRoleCnt" label="活跃人数" show-overflow-tooltip min-width="90px">
                </el-table-column>
                <el-table-column prop="familyWarRoleCnt" label="参数家族战人数" show-overflow-tooltip min-width="130px">
                </el-table-column>
                <el-table-column prop="familyRoleCnt" label="家族人数" show-overflow-tooltip min-width="90px">
                </el-table-column>
                <el-table-column prop="totalCharge" label="家族人员总充值" show-overflow-tooltip min-width="130px">
                </el-table-column>
                <el-table-column prop="totalCostCoin" label="金子总消耗" show-overflow-tooltip min-width="100px">
                </el-table-column>
                <el-table-column prop="liveness" label="整体活跃度" show-overflow-tooltip min-width="100px">
                </el-table-column>
                <el-table-column prop="familyLevel" label="家族等级" show-overflow-tooltip min-width="90px">
                </el-table-column>
                <el-table-column prop="outcomeList" label="胜负榜" show-overflow-tooltip min-width="90px">
                </el-table-column>
                <el-table-column prop="winRate" label="胜率" show-overflow-tooltip min-width="90px">
                </el-table-column>
                <el-table-column prop="honour" label="荣耀值" show-overflow-tooltip min-width="90px">
                </el-table-column>
                <el-table-column prop="countryWarRoleCnt" label="参与国战人数" show-overflow-tooltip min-width="110px">
                </el-table-column>
                <el-table-column prop="familyStatus" label="家族状态" show-overflow-tooltip min-width="90px">
                  <template slot-scope="scope">
                    {{scope.row[scope.column.property] | familyStatustype}}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button size="mini" style="padding: 4px 5px;" type="success">战斗详情</el-button>
                    <el-button size="mini" style="padding: 4px 5px;" type="danger">维护中</el-button>
                    <!-- @click="zidingyishijiandelete(scope.$index, scope.row)" -->
                  </template>
                </el-table-column>
              </el-table>
              <div class="block" style="padding-bottom:10px">
                <el-pagination :current-page="tiaojian.pageNo" :page-sizes="[10,15, 20, 30, 50]" :page-size="tiaojian.pageSize" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5" :total="dataLength"
                  style="margin-top:10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
              </div>

            </div>
          </div>
        </el-col>
      </el-row>

    </div>
    <el-dialog title="指标说明" :visible.sync="dialogTipsVisible" width="70%" top="10vh">
      <el-table :data="gridTipsData" border highlight-current-row height="600" class="tips_table">
        <el-table-column property="title" label="指标" width="150"></el-table-column>
        <el-table-column property="content" label="定义"></el-table-column>
        <el-table-column property="desc" label="备注" width="250"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  ajax_handleBusinessByTargetKpi,
  ajax_zitiaojiandata,
  ajax_datadownload
} from "@Gms~/api/ajax_model";

import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  name: "GS_FAMILY_LIST",
  components: {},
  data() {
    return {
      qufu_list: [],
      guojia_list: [],
      tiaojian: {
        pageNo: 1, //   (当前页)
        pageSize: 20, //   (每页条数)
        queryTime: "", //   (查询时间)
        countryIds: "", //(国家id，多个以,分割)
        serverIds: "", //(区服id，多个以,分割)
        familyName: ""
      },
      countryIds: [], //(国家id，多个以,分割)
      serverIds: [], //(区服id，多个以,分割)
      header_server_codeold: [],
      header_countryIds_codeold: [],
      tableData: {
        page: {
          result: []
        },
        thead: []
      },
      dataLength: 0,
      loadding: false,
      targetDate:"",

      dialogTipsVisible: false,
      gridTipsData: [
        {title:"	家族战开始时间	",content:"	周四、周六21：00	",desc:"	2021-03-17更新，之前没有此条	"},
{title:"	国家	",content:"	该家族所属的国家	",desc:"		"},
{title:"	家族	",content:"	家族名称	",desc:"		"},
{title:"	成立时间	",content:"	该家族的成立时间	",desc:"		"},
{title:"	活跃日期	",content:"	与用户在筛选区所筛选的时间一致	",desc:"		"},
{title:"	活跃战斗力	",content:"	该家族在“活跃日期”中活跃成员的总战斗力	",desc:"		"},
{title:"	不活跃战斗力	",content:"	该家族在“活跃日期”中不活跃成员的总战斗力	",desc:"		"},
{title:"	活跃人数	",content:"	该国家在“活跃日期”中活跃成员的数量	",desc:"		"},
{title:"	参数家族战人数	",content:"	该家族在“活跃日期”中参与家族战的人数	",desc:"		"},
{title:"	家族人数	",content:"	该家族总人数	",desc:"		"},
{title:"	家族人员总充值	",content:"	家族成员从创角到所选“活跃日期”的累计充值	",desc:"		"},
{title:"	金子总消耗	",content:"	在玩家选择的“统计时间段”中消耗的金子总量	",desc:"		"},
{title:"	整体活跃度	",content:"	家族在所选日期的整体活跃度	",desc:"		"},
{title:"	家族等级	",content:"	家族在所选日期的等级	",desc:"		"},
{title:"	胜负榜	",content:"	家族战的胜利次数 — 失败次数	",desc:"		"},
{title:"	胜率	",content:"	胜利次数/战斗总次数*100%	",desc:"		"},
{title:"	荣耀值	",content:"	家族在所选日期的荣耀值	",desc:"		"},
{title:"	参与国战人数	",content:"	该国家在“活跃日期”中参与国战的人数	",desc:"		"},


      ],
    };
  },
  created() {
    var timezone = decodeURIComponent(window.sessionStorage.getItem('productTimeZone')).replace("UTC", ""); //目标时区时间，东八区
    var offset_GMT = new Date().getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
    var nowDate = new Date().getTime(); // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
    this.targetDate = new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000);
    this.tiaojian.queryTime = new Date(
      new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 1)
    ).Format("yyyy-MM-dd")

    this.tiaojian_handleBusinessByTargetKpi();
    this.zitiaojiandata("", "header_server_code");
    this.list_handleBusinessByTargetKpi();
  },
  mounted() {},
  methods: {
    mohuchaxun() {
      this.list_handleBusinessByTargetKpi();
    },
    tiaojian_handleBusinessByTargetKpi() {
      //国家列表
      ajax_handleBusinessByTargetKpi("gs_1_3_1", {}).then(
        response => {
          console.log("国家列表");
          console.log(response);
          if (response.code == 1) {
            response.data.unshift({ name: "全选", code: "" });
            this.guojia_list = response.data;
          }
        }
      );
    },
    houtai_exportExcel() {
      this.tiaojian.countryIds = this.countryIds.join(",");
      this.tiaojian.serverIds = this.serverIds.join(",");
      if (this.tiaojian.countryIds.substring(0, 1) == ",") {
        this.tiaojian.countryIds = this.tiaojian.countryIds.substring(
          1,
          this.tiaojian.countryIds.length
        );
      }
      if (this.tiaojian.serverIds.substring(0, 1) == ",") {
        this.tiaojian.serverIds = this.tiaojian.serverIds.substring(
          1,
          this.tiaojian.serverIds.length
        );
      }
      console.log(this.tiaojian);
      ajax_datadownload("gs_2_4_1_d", this.tiaojian);
    },
    list_handleBusinessByTargetKpi() {
      this.loadding = true;
      this.tiaojian.countryIds = this.countryIds.join(",");
      this.tiaojian.serverIds = this.serverIds.join(",");
      if (this.tiaojian.countryIds.substring(0, 1) == ",") {
        this.tiaojian.countryIds = this.tiaojian.countryIds.substring(
          1,
          this.tiaojian.countryIds.length
        );
      }
      if (this.tiaojian.serverIds.substring(0, 1) == ",") {
        this.tiaojian.serverIds = this.tiaojian.serverIds.substring(
          1,
          this.tiaojian.serverIds.length
        );
      }
      console.log(this.tiaojian);
      //家族列表list
      ajax_handleBusinessByTargetKpi(
        "gs_2_4_1",
        this.tiaojian
      ).then(response => {
        console.log("家族列表");
        console.log(response);
        if (response.code == 1) {
          this.tableData = response.data;
          this.dataLength = response.data.page.totalCount;
        }

        this.loadding = false;
      });
    },
    zitiaojiandata(data, name) {
      ajax_zitiaojiandata(data, name).then(response => {
        console.log(response);
        if (response.code == 1) {
          var datas = response.data;
          if (name == "header_server_code") {
            response.data.unshift({ key: "全选", value: "" });
            this.qufu_list = response.data;
          }
        } else {
          this.$message({
            type: "warning",
            message: response.msg
          });
        }
      });
    },
    handleSizeChange(e) {
      // table 分页数量变化
      this.tiaojian.pageSize = e;
      this.list_handleBusinessByTargetKpi();
    },
    handleCurrentChange(e) {
      // table 分页变化
      this.tiaojian.pageNo = e;
      this.list_handleBusinessByTargetKpi();
    },
    exportExcel(e) {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(
        document.querySelector("#xiazaishijian")
      );
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "事件列表.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },

    selectmultipleChanne(e, oldlist, list, val) {
      // select多选
      //变化
      let allValues = [];
      //保留所有值
      for (let item of list) {
        allValues.push(item.value);
      }
      // 用来储存上一次的值，可以进行对比
      const oldVal = oldlist.length === 0 ? [] : oldlist[1];
      // 若是全部选择
      if (val.includes("")) this.serverIds = allValues;
      // 取消全部选中  上次有 当前没有 表示取消全选
      if (oldVal.includes("") && !val.includes("")) this.serverIds = [];
      // 点击非全部选中  需要排除全部选中 以及 当前点击的选项
      // 新老数据都有全部选中
      if (oldVal.includes("") && val.includes("")) {
        const index = val.indexOf("");
        val.splice(index, 1); // 排除全选选项
        this.serverIds = val;
      }
      //全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
      if (!oldVal.includes("") && !val.includes("")) {
        if (val.length === allValues.length - 1)
          this.serverIds = [""].concat(val);
      }
      //储存当前最后的结果 作为下次的老数据
      oldlist[1] = this.serverIds;
      var sid = [];
      for (var i = 0; i < this.serverIds.length; i++) {
        if (this.serverIds[i] != "") {
          sid.push(this.serverIds[i]);
        }
      }
      console.log(sid);
    },
    countryIdsChanne(e, oldlist, list, val) {
      // select多选
      //变化
      let allValues = [];
      //保留所有值
      for (let item of list) {
        allValues.push(item.code);
      }
      // 用来储存上一次的值，可以进行对比
      const oldVal = oldlist.length === 0 ? [] : oldlist[1];
      // 若是全部选择
      if (val.includes("")) this.countryIds = allValues;
      // 取消全部选中  上次有 当前没有 表示取消全选
      if (oldVal.includes("") && !val.includes("")) this.countryIds = [];
      // 点击非全部选中  需要排除全部选中 以及 当前点击的选项
      // 新老数据都有全部选中
      if (oldVal.includes("") && val.includes("")) {
        const index = val.indexOf("");
        val.splice(index, 1); // 排除全选选项
        this.countryIds = val;
      }
      //全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
      if (!oldVal.includes("") && !val.includes("")) {
        if (val.length === allValues.length - 1)
          this.countryIds = [""].concat(val);
      }
      //储存当前最后的结果 作为下次的老数据
      oldlist[1] = this.countryIds;
      var sid = [];
      for (var i = 0; i < this.countryIds.length; i++) {
        if (this.countryIds[i] != "") {
          sid.push(this.countryIds[i]);
        }
      }
      console.log(sid);
    },
    handleAgeSortChange(e) {
      console.log(e);
      if (e.order == "ascending") {
        var order = true;
      } else if (e.order == "descending") {
        var order = false;
      }
      if (e.order == null) {
        this.rz_tableData2 = JSON.parse(JSON.stringify(this.rz_tableData2copy));
      } else {
        this.rz_tableData2.tbody.sort(this.sortBy(e.prop, order));
      }
    },
    sortBy(attr, rev) {
      // 第二个参数没有传递 默认升序排列
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
      }

      return function(a, b) {
        // a = a[attr];
        // b = b[attr];
        if (!isNaN(Number(a[attr])) && !isNaN(Number(b[attr]))) {
          a = Number(a[attr]);
          b = Number(b[attr]);
        } else {
          a = a[attr];
          b = b[attr];
        }

        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      };
    }
  },
  filters: {
    familyStatustype(value) {
      if (value == "1") {
        return "正常";
      } else {
        return "异常";
      }
    },
    platformTypes(value) {
      if (value == "1") {
        return "服务端事件";
      } else if (value == "2") {
        return "客户端事件";
      }
    },
    eventTypes(value) {
      if (value == "0") {
        return "公共事件";
      } else if (value == "3") {
        return "必传参数";
      } else if (value == "1") {
        return "自定义事件";
      }
    },
    eventDescsub(value) {
      if (value.length > 25) {
        return value.substring(0, 25) + "...";
      } else {
        return value;
      }
    },
    eventNamesub(value) {
      if (value.length > 10) {
        return value.substring(0, 10) + "...";
      } else {
        return value;
      }
    },
    dataEmptys(value) {
      if (value == "0") {
        return "否";
      } else if (value == "1") {
        return "是";
      }
    },
    ispresets(value) {
      if (value == "0") {
        return "否";
      } else if (value == "1") {
        return "是";
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding: 10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}
.tb-edit ::v-deep .el-table__body-wrapper {
  z-index: 1;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-dialog__body {
  padding: 10px 5px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.tb-edit1 tr td .cell {
  /* padding: 5px 2px !important; */
}

.el-table th {
  background-color: #fff;
}

.el-table.tips_table tr td .cell {
  padding: 6px 2px !important;
  font-size: 12px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>
